<template>
  <div class="container has-text-centered p-t-xl p-b-md p-l-md p-r-md">
    <div class="columns">
      <div class="column">
        <img
          src="@/assets/images/logo_horizontal.svg"
          alt="Logo CA horizontal"
        />
      </div>
      <div class="column has-text-right">
        <img
          src="@/assets/images/slogan.svg"
          alt="Eslogan CA"
          class="slogan m-t-sm"
        />
      </div>
    </div>
    <div class="columns is-multiline has-text-left is-size-5">
      <div
        class="column is-4 has-text-weight-bold has-text-centered has-text-left-desktop experience-item m-b-md"
      >
        <img
          class="is-inline-block m-r-md"
          src="@/assets/icons/hand-key.svg"
          alt="Imagen Administración de inmueble"
        />
        <div class="is-inline-block">Administración de inmuebles</div>
      </div>
      <div
        class="column is-4 has-text-weight-bold has-text-centered has-text-left-desktop experience-item m-b-md"
      >
        <img
          class="is-inline-block m-r-md"
          src="@/assets/icons/buildings.svg"
          alt="Imagen Renta y venta de propiedades"
        />
        <div class="is-inline-block">Renta y venta de propiedades</div>
      </div>
      <div
        class="column is-4 has-text-weight-bold has-text-centered has-text-left-desktop experience-item m-b-md"
      >
        <img
          class="is-inline-block m-r-md"
          src="@/assets/icons/office-worker.svg"
          alt="Imagen Acompañamiento en procesos"
        />
        <div class="is-inline-block">Acompañamiento en procesos</div>
      </div>
      <div
        class="column is-4 has-text-weight-bold has-text-centered has-text-left-desktop experience-item m-b-md"
      >
        <img
          class="is-inline-block m-r-md"
          src="@/assets/icons/time-money.svg"
          alt="Imagen Pago de rentas a tiemp"
        />
        <div class="is-inline-block">Pago de rentas a tiempo</div>
      </div>
      <div
        class="column is-4 has-text-weight-bold has-text-centered has-text-left-desktop experience-item m-b-md"
      >
        <img
          class="is-inline-block m-r-md"
          src="@/assets/icons/hand-house.svg"
          alt="Imagen Mantenimiento de propiedades"
        />
        <div class="is-inline-block">Mantenimiento de propiedades</div>
      </div>
      <div
        class="column is-4 has-text-weight-bold has-text-centered has-text-left-desktop experience-item m-b-md"
      >
        <img
          class="is-inline-block m-r-md"
          src="@/assets/icons/shield-check.svg"
          alt="Imagen Seguridad para propietarios e inquilinos"
        />
        <p class="is-inline-block">
          Seguridad para propietarios e <br />inquilinos
        </p>
      </div>
    </div>
    <b-button
      class="has-text-weight-semibold m-t-sm m-r-sm"
      type="is-primary-green"
      @click="$router.push({ name: 'manage-properties' })"
    >
      Vende o renta tu propiedad
    </b-button>
    <b-button
      class="has-text-weight-semibold m-t-sm"
      type="is-primary"
      @click="$router.push({ name: 'properties' })"
    >
      Ver propiedades
    </b-button>
    <hr class="m-t-lg" />
    <div class="bottom-section">
      <div class="m-b-md content">
        <span class="members-text has-text-weight-semibold is-size-5">
          Somos miembros de:
        </span>
        <img
          src="@/assets/images/logo-AMPI.png"
          class=""
          alt="Asociación Mexicana de Profesionales Inmobiliarios, A.C."
        />
        <img
          src="@/assets/images/logo-MIO.png"
          class=""
          alt="Movimiento inmobiliario de occidente"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeExperience"
};
</script>

<style lang="scss" scoped>
.top-section {
  img.laurel {
    width: 64px;
  }
}

.experience-item {
  img {
    margin-bottom: -0.5em;
  }
}

.experience-item:last-child img {
  margin-bottom: 0em;
}

hr {
  background-color: $grey;
}

.bottom-section {
  display: flex;
  justify-content: center;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    margin-top: 2rem;
    height: 50px;
  }
}
.slogan {
  height: 50%;
}

@media only screen and (min-width: 1024px) {
  .top-section {
    img.laurel {
      width: auto;
    }
  }

  .bottom-section {
    .content {
      flex-direction: row;
    }

    img {
      margin-top: 0;
      margin-left: 4rem;
    }
  }
}
</style>
